module.exports = "https://static.zego.com/_next/static/images/ScooterPAYGInsurance-6dbc39cbbb4fc588597cf15603b23a80.jpg";